import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "./login/-LoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    redirect?: string;
    error?: string;
  } => {
    const result: { redirect?: string; error?: string } = {};
    if (search.redirect) {
      result.redirect = search.redirect as string;
    }
    if (search.error) {
      result.error = search.error as string;
    }
    return result;
  },
  component: LoginPage,
});
